import { CssBaseline } from '@mui/material';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LPAppBar from '../../app/components/LPAppBar';
import LPDrawer from '../../app/components/LPDrawer';
import ShiftHome from '../../app/components/ShiftHome';
import { useStyles } from '../../assets/styles/DefaultPageStyle';
import { SizeMe } from '../../felles/useResizeObserver';
import Utils from '../../felles/Utils';
import MenuItemTarget from '../../models/MenuItemTarget';
import UISize from '../../models/UISize';
import * as actions from '../../store/actions/index';
import { AppState } from '../../store/rootReducer';
import NE01Forsendelseskoder from './NE01Forsendelseskoder';

/** NE01 Forsendelseskoder - erstatter FORS (CICSFORS). */
export default function NE01Page() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const screenSize: UISize = useSelector(state => (state as AppState).ui.screenSize);
  const open = screenSize.width > 0 && screenSize.width < 1200 ? false : true;
  const navigate = useNavigate();
  const n: MenuItemTarget = useSelector((state) => (state as AppState).menuItem.menuItemTarget);
  const button: boolean = useSelector((state) => (state as AppState).ui.isSandwichButtonTurnedOn);

  // F3 / Shift+End tilbake til menyen, som PF3 i FORS.
  const handlePressedKey = (event: any) => {
    const { key } = event;
    if ((event.shiftKey && key === 'F7') || key === 'F8') {
      event.preventDefault();
    }
    if ((event.shiftKey && key === 'End') || key === 'F3') {
      event.preventDefault();
      dispatch(actions.menuItemSetTarget(new MenuItemTarget(n.rootItem, n.item !== '' ? n.item : n.rootItem, '', '', n.tilpasset, n.prodSynlig
        , n.kodeSynlig, n.labelSynlig, n.menuSynlig, n.hasChildren, n.title)));
      dispatch(actions.menuItemSetSelected([n.rootItem, n.item + n.rootItem]));
      navigate(Utils.HOMEPAGE_CONTEXT + '/menu');
    }
  };

  return (
    <div className={classes.root} tabIndex={0} onKeyDown={(e) => handlePressedKey(e)}>
      <ShiftHome />
      <CssBaseline />
      <LPDrawer />
      <main className={clsx(classes.content, { [classes.contentShift]: button ? true : open })}>
        <LPAppBar ismenuvisible={true} />
        <SizeMe>{({ size }) => <NE01Forsendelseskoder size={size} />}</SizeMe>
      </main>
    </div>
  );
}
